import { Category } from '@/themes/variant-interfaces/Category';
import { SxProps, Theme } from '@mui/material';
import { Stack } from '@mui/material';
import { Text } from '@/components/DesignSystem';

interface TextBadgeProps {
  backgroundColor?: string,
  sx?: SxProps<Theme>,
  textColor?: string,
  textCategory?: Category,
  textSx?: SxProps<Theme>,
  text: string,
}

export const TextBadge = ({
  backgroundColor = '#1890FF',
  sx,
  textColor = 'white',
  textSx,
  text,
  textCategory = 'label-small',
}: TextBadgeProps) => {
  const defaultSx: SxProps<Theme> = {
    bgcolor: backgroundColor,
    borderRadius: '4px',
    color: textColor,
    height: '16px',
    justifyContent: 'center',
    px: '6px',
  };

  return (
    <Stack
      sx={sx ? { ...defaultSx, ...sx } : defaultSx}
    >
      <Text
        category={textCategory}
        sx={textSx}
      >
        {text}
      </Text>
    </Stack>
  );
};
